import { Component, Inject, ViewChild, ElementRef, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-cps-choix-situation',
  templateUrl: './cps-choix-situation.component.html',
  styleUrls: ['./cps-choix-situation.component.scss'],
})
export class CpsChoixSituationComponent implements OnInit {
  @ViewChild('situationinconnu') situationinconnu: ElementRef;
  public modeRP:boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public situations: any[], // Liste des situations passées à la boîte de dialogue
    private dialogRef: MatDialogRef<CpsChoixSituationComponent>
  ) {}
  ngOnInit(): void {
    if(this.situations[0].idRemplacant){
      //mode remplaçant actif on doit choisir qui ont remplace
      this.modeRP = true
    }
  }

  // Méthode pour sélectionner une situation
  selectSituation(situation: any): void {
    if(situation.idJfse>0){
      this.dialogRef.close(situation); // Ferme la boîte de dialogue avec la situation sélectionnée
    }
  }

  // Méthode pour fermer la boîte de dialogue sans sélectionner
  close(): void {
    this.dialogRef.close();
  }
}
